import { render, staticRenderFns } from "./CardAdminOrg.vue?vue&type=template&id=77c45b9f"
import script from "./CardAdminOrg.vue?vue&type=script&lang=js"
export * from "./CardAdminOrg.vue?vue&type=script&lang=js"
import style0 from "./CardAdminOrg.vue?vue&type=style&index=0&id=77c45b9f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports